import React from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import "../../../../node_modules/ag-grid-community/styles/ag-grid.css";
import "../../../../node_modules/ag-grid-community/styles/ag-theme-quartz.css";
import { useImport } from '../../../Hooks/Features/ImportStatus/useImport';
import { SkeletonCard } from '../../../components/Loader/Loader';
import { Dialog } from 'primereact/dialog';


export const ImportStatus = () => {
    const { loader, handleErrors, syncColumn, showPopUp, setShowPopUp, importStatusInfo, rowData } = useImport();

    return (
        loader ?   <div className="row">
                      <SkeletonCard numSkeletons={10} height={'200px'} />
                    </div> :
            <div>
                <div className='row'>
                    <div className='col-md-12'>
                        <h5>Import Status</h5>
                    </div>
                </div>
                <div className='import-status-cards'>
                    {importStatusInfo?.map((item, i) => (
                        <div class="import-card" style={{ borderTopColor: !item?.error_count ? '#09a909' : '#d70000' }}>
                            <div class="import-card-header">
                                <img src={"./assets/srkay-icon.png"} className="outpasslist-profile-image" alt="" />
                                <span class="import-title" title={item?.config_name}>
                                   {item?.config_name}
</span>
                            </div>
                            <hr />
                            <div class="import-card-body">
                                <p>Last Sync : <span class="time">{item?.last_synced}</span></p>
                                <p>Errors : <span class="error" onClick={() => handleErrors(item)}>{item?.error_count ?? "0"}
                                </span></p>
                            </div>
                        </div>
                    ))}
                </div>
                <Dialog
                    header='Error Details'
                    className=''
                    modal={true}
                    draggable={false}
                    style={{ width: '50vw', minHeight: "50%" }}
                    visible={showPopUp}
                    onHide={() => setShowPopUp(false)}
                >
                    <div className="ag-theme-alpine" style={{ height: 'calc(100vh - 130px)' }}>
                        <AgGridReact columnDefs={syncColumn}
                            rowData={rowData}
                            rowHeight={30}
                            headerHeight={30} />
                    </div>
                </Dialog>
            </div>
    )

}
export default ImportStatus;